var _g, _path, _path2, _path3, _path4, _path5, _g2, _path6, _path7, _path8, _path9, _g3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1512,
    height: 659,
    viewBox: "0 0 1512 659",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M72.8918 614.438C85.5348 612.884 94.527 601.381 92.9763 588.745C91.4256 576.109 79.9193 567.124 67.2762 568.677C54.6332 570.231 45.641 581.734 47.1917 594.37C48.7424 607.006 60.2487 615.991 72.8918 614.438Z",
    fill: "#CFDAE6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M7.83834 584.916C10.8666 584.544 13.0203 581.789 12.6489 578.763C12.2775 575.736 9.52155 573.584 6.49333 573.956C3.46511 574.328 1.31134 577.083 1.68276 580.11C2.05417 583.136 4.81012 585.288 7.83834 584.916Z",
    fill: "#CFDAE6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5605 653.587C56.6169 652.843 60.9245 647.332 60.1816 641.279C59.4388 635.226 53.9269 630.922 47.8705 631.666C41.814 632.41 37.5065 637.92 38.2493 643.974C38.9921 650.027 44.504 654.331 50.5605 653.587Z",
    fill: "#CFDAE6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M70.9125 592.205L126.474 567.662",
    stroke: "#CFDAE6",
    strokeWidth: 1.73913,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M46.7916 588.049L9.06799 579.948",
    stroke: "#E0B4B7",
    strokeWidth: 0.702679,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.41 2.11"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M70.5903 592.619L53.923 632.871",
    stroke: "#BACAD9",
    strokeWidth: 0.702679,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.41 2.11"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M129.957 572.183C134.874 574.271 140.551 571.98 142.636 567.065C144.721 562.151 142.426 556.474 137.509 554.386C132.592 552.299 126.915 554.59 124.83 559.504C122.744 564.419 125.04 570.095 129.957 572.183Z",
    fill: "#CFDAE6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.83 559.505C122.744 564.419 125.04 570.096 129.957 572.183C134.874 574.271 140.551 571.98 142.636 567.066L124.83 559.505Z",
    fill: "#CFDAE6"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M139.993 106.621C156.955 105.136 169.502 90.1674 168.017 73.1876C166.533 56.2078 151.578 43.6467 134.616 45.1315C117.654 46.6164 105.107 61.5849 106.592 78.5647C108.077 95.5445 123.031 108.106 139.993 106.621Z",
    fill: "#CFDAE6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M139.296 98.6499C151.86 97.5501 161.155 86.4623 160.055 73.8846C158.955 61.307 147.878 52.0025 135.313 53.1024C122.749 54.2023 113.455 65.2901 114.555 77.8677C115.654 90.4453 126.731 99.7498 139.296 98.6499Z",
    fill: "#CFDAE6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M307.663 202.101C321.484 200.891 331.708 188.694 330.498 174.859C329.288 161.023 317.103 150.788 303.282 151.998C289.461 153.208 279.238 165.405 280.448 179.24C281.658 193.076 293.842 203.311 307.663 202.101Z",
    stroke: "#CFDAE6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M138.3 87.263C144.582 86.7131 149.229 81.1692 148.68 74.8804C148.13 68.5916 142.591 63.9393 136.309 64.4893C130.027 65.0392 125.38 70.5831 125.929 76.8719C126.479 83.1607 132.018 87.813 138.3 87.263Z",
    fill: "#BACAD9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.3 87.263L136.309 64.489C130.027 65.0389 125.38 70.5829 125.93 76.8718C126.479 83.1607 132.018 87.813 138.3 87.263Z",
    fill: "#BACAD9"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M306.07 183.882C309.84 183.552 312.628 180.225 312.298 176.452C311.969 172.679 308.645 169.888 304.876 170.218C301.107 170.548 298.318 173.874 298.648 177.647C298.978 181.42 302.301 184.212 306.07 183.882Z",
    fill: "#E6A1A6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M306.071 183.882C302.301 184.212 298.978 181.42 298.648 177.647C298.318 173.874 301.107 170.547 304.876 170.217L306.071 183.882Z",
    fill: "#E6A1A6"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M347.19 175.693C348.132 175.611 348.829 174.779 348.747 173.836C348.664 172.893 347.834 172.195 346.891 172.277C345.949 172.36 345.252 173.191 345.334 174.135C345.417 175.078 346.248 175.776 347.19 175.693Z",
    fill: "#CFDAE6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M309.627 217.994C310.569 217.911 311.266 217.079 311.184 216.136C311.101 215.193 310.271 214.495 309.328 214.577C308.386 214.66 307.689 215.492 307.771 216.435C307.854 217.378 308.685 218.076 309.627 217.994Z",
    fill: "#E0B4B7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M303.523 141.65C304.779 141.54 305.709 140.431 305.599 139.173C305.489 137.915 304.381 136.985 303.125 137.095C301.868 137.205 300.939 138.314 301.049 139.571C301.159 140.829 302.266 141.76 303.523 141.65Z",
    fill: "#E0B4B7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M137.255 76.7632L296.687 172.212",
    stroke: "#CFDAE6"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M1134.38 47.2711C1140.8 46.0223 1144.99 39.7531 1143.73 33.2685C1142.47 26.7839 1136.24 22.5395 1129.82 23.7883C1123.4 25.0371 1119.21 31.3063 1120.47 37.7909C1121.73 44.2755 1127.96 48.52 1134.38 47.2711Z",
    stroke: "#CFDAE6",
    strokeWidth: 0.941176
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M1133.8 44.4308C1138.66 43.4846 1141.83 38.7352 1140.88 33.8228C1139.92 28.9103 1135.2 25.6951 1130.34 26.6413C1125.47 27.5876 1122.3 32.3369 1123.26 37.2494C1124.21 42.1618 1128.93 45.3771 1133.8 44.4308Z",
    fill: "#BACAD9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1133.8 44.4315C1138.66 43.4853 1141.83 38.7357 1140.88 33.8231C1139.92 28.9105 1135.2 25.6951 1130.34 26.6414L1133.8 44.4315Z",
    fill: "#BACAD9"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M1121.13 29.9028L1087 14.9189",
    stroke: "#CFDAE6",
    strokeWidth: 0.941176
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M1084.82 17.305C1086.69 16.9407 1087.91 15.1122 1087.55 13.2209C1087.18 11.3295 1085.36 10.0916 1083.49 10.4558C1081.62 10.82 1080.4 12.6485 1080.76 14.5399C1081.13 16.4312 1082.95 17.6692 1084.82 17.305Z",
    stroke: "#CFDAE6",
    strokeWidth: 0.941176
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M1095.93 77.0876C1097.54 76.7754 1098.59 75.2081 1098.27 73.5869C1097.96 71.9658 1096.4 70.9046 1094.79 71.2169C1093.19 71.5291 1092.14 73.0964 1092.46 74.7175C1092.77 76.3387 1094.33 77.3998 1095.93 77.0876Z",
    fill: "#F7E1AD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M1124.03 44.9668L1097.44 72.2475",
    stroke: "#CFDAE6",
    strokeWidth: 0.941176
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M1367.72 456.836C1367.13 450.038 1361.13 445.01 1354.34 445.605C1347.54 446.2 1342.51 452.193 1343.11 458.991C1343.7 465.789 1349.69 470.817 1356.49 470.222C1363.29 469.627 1368.31 463.634 1367.72 456.836Z",
    fill: "#BACAD9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1356.49 470.223C1363.29 469.628 1368.31 463.634 1367.72 456.836C1367.13 450.038 1361.13 445.01 1354.34 445.605L1356.49 470.223Z",
    fill: "#BACAD9"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M1416.76 434.754C1420.12 434.161 1422.37 430.957 1421.77 427.597C1421.18 424.237 1417.98 421.993 1414.62 422.586C1411.26 423.179 1409.02 426.383 1409.61 429.743C1410.2 433.103 1413.4 435.347 1416.76 434.754Z",
    fill: "#CFDAE6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M1355.11 440.767L1354.08 364.367",
    stroke: "#BACAD9",
    strokeWidth: 1.16667
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M1214.26 410.251L1340.01 452.924",
    stroke: "#BACAD9",
    strokeWidth: 1.16667
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M1361.32 473.539L1414.13 583.88L1256.42 521.306L1341.3 466.889",
    stroke: "#CFDAE6",
    strokeWidth: 1.16667
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1374.15 449.167L1409.32 431.675",
    stroke: "#E0B4B7",
    strokeWidth: 1.16667
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M1418.35 422.433L1444.72 368.344",
    stroke: "#BACAD9",
    strokeWidth: 1.16667
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M1491.58 463.39L1421.7 430.749",
    stroke: "#CFDAE6",
    strokeWidth: 1.16667
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M1355.99 363.919C1361.03 363.03 1364.39 358.223 1363.5 353.183C1362.61 348.143 1357.81 344.778 1352.77 345.667C1347.73 346.556 1344.37 351.362 1345.25 356.402C1346.14 361.443 1350.95 364.808 1355.99 363.919Z",
    fill: "#C1D1E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M1258.22 527.963C1261.24 527.429 1263.26 524.545 1262.73 521.521C1262.2 518.497 1259.31 516.478 1256.29 517.012C1253.27 517.545 1251.25 520.429 1251.78 523.453C1252.31 526.477 1255.2 528.496 1258.22 527.963Z",
    fill: "#C1D1E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M1206 416.723C1211.04 415.834 1214.4 411.027 1213.51 405.987C1212.63 400.947 1207.82 397.582 1202.78 398.471C1197.74 399.36 1194.38 404.166 1195.27 409.206C1196.15 414.246 1200.96 417.612 1206 416.723Z",
    fill: "#D1DEED",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M1450.05 367.404C1453.41 366.811 1455.65 363.607 1455.06 360.246C1454.46 356.886 1451.26 354.643 1447.9 355.236C1444.54 355.828 1442.3 359.033 1442.89 362.393C1443.48 365.753 1446.69 367.996 1450.05 367.404Z",
    fill: "#D1DEED",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M1415.99 590.473C1419.01 589.939 1421.03 587.055 1420.5 584.031C1419.97 581.007 1417.08 578.988 1414.06 579.521C1411.04 580.055 1409.02 582.939 1409.55 585.963C1410.08 588.987 1412.97 591.006 1415.99 590.473Z",
    fill: "#E0B4B7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.abf358d5662124c3415d2e1830f9bde8.svg";
export { ForwardRef as ReactComponent };